import React from "react";
import {
    isDerivedColumnGridSection,
    renderDerivedColumnGridSectionBody
} from "./derivedColumnGridSectionRenderer";
import {
    isMasterDetailGridSection,
    renderMasterDetailGridSectionBody
} from "./masterDetailGridSectionRenderer";
import {
    isProjectedDisplayGridSection,
    renderProjectedDisplayGridSectionBody
} from "./projectedDisplayGridSectionRenderer";
import { renderBaseSectionBody } from "./baseSectionRenderer";
import { renderGridSectionBody } from "./gridSectionRenderer";
import {
    isStandardLayoutSection,
    renderStandardLayoutSectionBody
} from "./standardLayoutSectionRenderer";

// 特殊 Grid の描画直前補正をここへ寄せます。
function ensureSpecialGridRowsBeforeRender(section, gridSectionPanel, hasGridColumns, isEmpty) {
    if (!hasGridColumns || isEmpty(gridSectionPanel)) return;
    // TODO(kakousiji-cleanup): 描画直前補正を LoadData 側へ移設する
}

// 空セクション用の共通見た目を返します。
function renderEmptySectionBody() {
    return (
        <div
            style={{
                minHeight: 44,
                border: "1px solid #d0d0d0",
                borderRadius: 4,
                backgroundColor: "#fafafa",
                padding: "10px 12px",
                color: "#666"
            }}
        >
        </div>
    );
}

// セクション本体の描画分岐をまとめます。
export function renderSectionBodyContent({
    section,
    renderModel,
    sectionGridRowStyle,
    resolveGridIndex,
    EmptyPanel,
    Contents,
    renderActionArea,
    renderSustainableImagePanel,
    renderTotalGrid,
    renderSampleInfoSection,
    renderGenkaHeader,
    renderDemandHeader,
    buildDemandColumns,
    buildNouhinHeaderColumns,
    buildGenkaFixedColumns,
    buildBrandNameGridColumns,
    buildDemeritGridColumns,
    colorwayDetailParams,
    toStableAutoHeightPanel,
    genkaGridFixedHeight,
    isDemandSectionId,
    sectionTotalType,
    isEmpty
}) {
    const sectionPanel = renderModel.sectionPanel;
    const remarksSectionPanel = renderModel.remarksSectionPanel;
    const gridSectionPanel = renderModel.gridSectionPanel;
    const totalHostPanel = renderModel.totalHostPanel;
    const resolvedTotalType = renderModel.resolvedTotalType;
    const stableGridPanel = renderModel.stableGridPanel;

    const rowStyle = sectionGridRowStyle(section.id, gridSectionPanel);
    const hasGridBinding = !isEmpty(gridSectionPanel) && resolveGridIndex(gridSectionPanel) !== -1;
    const hasGridColumns = !isEmpty(gridSectionPanel) && hasGridBinding && !EmptyPanel(gridSectionPanel.id, gridSectionPanel.type);

    ensureSpecialGridRowsBeforeRender(section, gridSectionPanel, hasGridColumns, isEmpty);

    let baseBody = null;

    if (isStandardLayoutSection(section)) {
        baseBody = renderStandardLayoutSectionBody({
            section,
            sectionPanel,
            gridSectionPanel,
            stableGridPanel,
            resolvedTotalType,
            rowStyle,
            renderContents: Contents,
            renderTotalGrid,
            sectionTotalType,
            toStableAutoHeightPanel,
            isEmpty
        });
    }

    if (isEmpty(baseBody) && isMasterDetailGridSection(section)) {
        baseBody = renderMasterDetailGridSectionBody({
            section,
            gridSectionPanel,
            stableGridPanel,
            hasGridColumns,
            renderContents: Contents,
            colorwayDetailParams,
            toStableAutoHeightPanel
        });
    }

    if (isEmpty(baseBody) && isProjectedDisplayGridSection(section)) {
        baseBody = renderProjectedDisplayGridSectionBody({
            section,
            gridSectionPanel,
            stableGridPanel,
            hasGridColumns,
            rowStyle,
            renderContents: Contents,
            buildDemandColumns,
            buildBrandNameGridColumns,
            toStableAutoHeightPanel
        });
    }

    if (isEmpty(baseBody) && isDerivedColumnGridSection(section)) {
        baseBody = renderDerivedColumnGridSectionBody({
            section,
            gridSectionPanel,
            stableGridPanel,
            hasGridColumns,
            rowStyle,
            renderContents: Contents,
            buildDemandColumns,
            buildDemeritGridColumns,
            toStableAutoHeightPanel
        });
    }

    if (isEmpty(baseBody) && section.component === "base") {
        baseBody = renderBaseSectionBody({
            section,
            sectionPanel,
            totalHostPanel,
            renderContents: Contents,
            renderSustainableImagePanel,
            renderTotalGrid,
            sectionTotalType,
            isEmpty
        });
    }

    if (isEmpty(baseBody) && section.component === "nb") {
        if (!isEmpty(remarksSectionPanel)) {
            baseBody = Contents({ panel: remarksSectionPanel });
        } else {
            baseBody = renderEmptySectionBody();
        }
    }

    if (section.id === "sample_info") {
        baseBody = renderSampleInfoSection(section);
    } else if (isEmpty(baseBody) && section.component === "grid") {
        baseBody = renderGridSectionBody({
            section,
            gridSectionPanel,
            stableGridPanel,
            resolvedTotalType,
            hasGridColumns,
            rowStyle,
            renderContents: Contents,
            renderTotalGrid,
            renderGenkaHeader,
            renderDemandHeader,
            buildDemandColumns,
            buildNouhinHeaderColumns,
            buildGenkaFixedColumns,
            buildBrandNameGridColumns,
            colorwayDetailParams,
            toStableAutoHeightPanel,
            genkaGridFixedHeight,
            isDemandSectionId,
            sectionTotalType,
            isEmpty
        });
    }

    if (isEmpty(baseBody)) {
        baseBody = renderEmptySectionBody();
    }

    return (
        <div>
            {section.showActionArea ? renderActionArea(section) : null}
            {baseBody}
        </div>
    );
}
